import { useCampaignQuizResults } from '@/api/campaigns/campagin-quiz-results'
import { FC } from 'react'
import VideoQuizResults from '../VideoQuizResults'
import { useCampaign } from '@/api/campaigns/get'
import { Card } from '@mui/material'
import LoadingContainer from '@/common/components/LoadingContainer/LoadingContainer'

type CampaignVideoQuizResultsParams = {
  campaignId: string
}

const CampaignVideoQuizResults: FC<CampaignVideoQuizResultsParams> = ({ campaignId }) => {
  const { data: campaignData } = useCampaign(campaignId)
  const hasQuizzes = campaignData?.asset_metadata?.include_quiz !== false
  const { data: quizzesResults, isPending } = useCampaignQuizResults(campaignId, hasQuizzes)

  if (!campaignData || isPending)
    return (
      <Card>
        <LoadingContainer />
      </Card>
    )

  if (!hasQuizzes || !quizzesResults) {
    return null
  }

  return (
    <VideoQuizResults
      videoId={campaignData?.assets[0]._id}
      campaignScore={campaignData?.score}
      hasQuizzes={hasQuizzes}
      quizResults={quizzesResults[campaignData.assets[0]._id]}
    />
  )
}

export default CampaignVideoQuizResults
